import { Component, Inject, OnInit, Optional } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { shortDateTimeFormat } from "../../dateTimeHelpers";
import { Comment } from "../../models/comment";
import { CommentService } from "../../services/comment.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-chat-modal",
    templateUrl: "./chat-modal.component.html",
    styleUrls: ["./chat-modal.component.scss"],
    standalone: false
})
export class ChatModalComponent implements OnInit {
  dateTimeFormat: string = shortDateTimeFormat;
  documentId: string = null;
  constructor(
    @Optional() public dialogRef: MatDialogRef<ChatModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Comment[],
    private commentService: CommentService,
    private route: ActivatedRoute,
  ) { }

  async ngOnInit() {
    this.documentId = this.route.snapshot.paramMap.get('documentId');
    if (this.documentId)
      this.data = await this.commentService.getComments(this.documentId).toPromise();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
